import { render, staticRenderFns } from "./GrantRequest.vue?vue&type=template&id=57fcf6fd&scoped=true&"
import script from "./GrantRequest.vue?vue&type=script&lang=js&"
export * from "./GrantRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fcf6fd",
  null
  
)

export default component.exports